import { RoadPolicy, DivinityPolicy, TowerPolicy, gameplayTasks } from './policy'
const setTimer = window.setTimeout.bind(window), clearTimer = window.clearTimeout.bind(window), clock = performance.now.bind(performance)

export function createGameplayRunner({ adapter, identity, onState }) {
  let generation = 0, timer, state = 'idle', task, policy, owner, message = ''
  function emit() { onState({ state, message, loops: policy ? policy.wins : 0, point: 0 }) }
  function stop(text = '已停止；游戏中正在进行的战斗会继续结算') { generation++; clearTimer(timer); adapter.end(); state = 'idle'; message = text; emit() }
  function pause(text = '已暂停自动操作') { if (state !== 'running') return; generation++; clearTimer(timer); state = 'paused'; message = text; emit() }
  async function tick(epoch) {
    if (epoch !== generation || state !== 'running') return
    try {
      if (identity() !== owner) { stop('游戏或账号已变化，请重新开始'); return }
      const sample = await adapter.sample(task)
      if (epoch !== generation || state !== 'running') return
      const command = await policy.observe(sample)
      if (epoch !== generation || state !== 'running') return
      message = command.message
      if (command.state === 'paused') { pause(message); return }
      if (command.state === 'completed') { state = 'completed'; adapter.end(); emit(); return }
      if (command.action) {
        const issuingPolicy = policy
        const result = await adapter.execute(task, command, () => epoch === generation && state === 'running' && identity() === owner)
        // Retain an already-issued action when pause arrives during its await.
        if (policy === issuingPolicy && ['running', 'paused'].includes(state) && (!result || !result.skipped)) policy.acknowledge(command)
        if (epoch !== generation || state !== 'running') return
      }
      emit(); timer = setTimer(() => tick(epoch), 250)
    } catch (error) {
      if (epoch !== generation) return
      adapter.end(); state = 'error'; message = error.message || '玩法执行异常'; emit()
    }
  }
  return {
    start(id, loops, options = {}) {
      if (['running', 'paused'].includes(state)) throw new Error('请先停止当前任务')
      if (!gameplayTasks.some(t => t.id === id) || !Number.isInteger(loops) || loops < 0 || loops > 100) throw new Error('任务参数不正确')
      const nextPolicy = id === 'divinity-monsters' ? new DivinityPolicy(loops, clock, options) : id.startsWith('road-') ? new RoadPolicy(id, loops, clock) : new TowerPolicy(id, loops, clock)
      adapter.begin(id); task = id; policy = nextPolicy
      owner = identity(); state = 'running'; message = '正在读取游戏进度'; emit(); tick(++generation)
    },
    pause,
    resume() { if (state !== 'paused') return; if (identity() !== owner) { stop('账号已变化，请重新开始'); return }; policy.resume(); state = 'running'; tick(++generation) },
    stop, destroy() { stop('已退出工具') },
  }
}
